import { useEffect, useState } from "react";
import { fileUrl, isLegacyPath } from "@/lib/api";
import api from "@/lib/api";

// Renders an image from either the public Bunny CDN (fast, no auth needed) or
// the legacy authenticated /api/files proxy (for pre-migration Emergent
// paths). Legacy paths are fetched as a blob so the JWT never appears in the
// browser URL; Bunny paths are used directly in <img src=…> for maximum
// performance and native browser caching.
export default function AuthImage({ path, alt = "", className = "" }) {
  const [src, setSrc] = useState(() => (path && !isLegacyPath(path) ? fileUrl(path) : null));

  useEffect(() => {
    if (!path) {
      setSrc(null);
      return undefined;
    }
    if (!isLegacyPath(path)) {
      setSrc(fileUrl(path));
      return undefined;
    }
    // Legacy Emergent path — fetch as blob with auth
    let revoked = false;
    let blobUrl;
    (async () => {
      try {
        const resp = await api.get(`/files/${path}`, { responseType: "blob" });
        if (revoked) return;
        blobUrl = URL.createObjectURL(resp.data);
        setSrc(blobUrl);
      } catch {
        setSrc(null);
      }
    })();
    return () => {
      revoked = true;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [path]);

  if (!src) {
    return <div className={`bg-[#EAE3DB] animate-pulse ${className}`} />;
  }
  return <img src={src} alt={alt} className={className} loading="lazy" />;
}
